import React from 'react';
import PropTypes from 'prop-types';
import { ThemeSetup } from '../themes/ThemeSetup';
import './Spinner.css';
const Spinner = ({ width = 30, height = 30, small = false, large = false }) => {
  const style = small ? { width: 18, height: 18 } : large ? { width: 60, height: 60 } : { width, height };

  return (
    <div className="flex-row align-center justify-center full-height" name="Spinner">
      <img src={ThemeSetup.getImageURL('RingSpinner.svg')} style={style} />
    </div>
  );
};

Spinner.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  small: PropTypes.bool,
  large: PropTypes.bool
};

export default Spinner;

export const LoaderSpinner = function() {
  return (
    <div className="full-spinner align-center justify-center" name="Spinner">
      <img className="full-spinner-img" src={ThemeSetup.getImageURL('RingSpinner.svg')} />
    </div>
  );
};
